// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-tab-page',
    // #endregion
    // #region Data
    props: {
        name: {
            type: String,
            required: true,
            default: ''
        },
        title: {
            type: String,
            required: true
        },
    },
    // #endregion
    // #region Constructor
    beforeMount() {
        this.$parent?.addPage(this);
    },
    beforeUnmount() {
        this.$parent?.removePage(this);
    },
    // #endregion
    // #region Computed
    computed: {
        isActivePage() {
            if (!this.name) {
                return false;
            }
            return this.$parent?.isActivePage(this.name);
        }
    },
    // #endregion
});
// #endregion
